import { render, staticRenderFns } from "./OrbitEditProjectFormStep.vue?vue&type=template&id=d2c38f04&scoped=true"
import script from "./OrbitEditProjectFormStep.vue?vue&type=script&lang=ts"
export * from "./OrbitEditProjectFormStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitEditProjectFormStep.vue?vue&type=style&index=0&id=d2c38f04&prod&lang=scss&scoped=true"
import style1 from "./OrbitEditProjectFormStep.vue?vue&type=style&index=1&id=d2c38f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c38f04",
  null
  
)

export default component.exports